import { useLingui } from '@lingui/react/macro';
import React, { useCallback } from 'react';
import history from 'modules/overlay-canvas/addons/history';
import UDText from 'ud-ui/components/text';
import Selector from 'modules/template-editor/ui/components/elements/selector';
import PlayerRoleHint from './player-role-hint';
import { useEditorManager } from 'modules/template-editor/ui/context';

interface IProps {
  onChange: (playerIndex: 0 | 1) => void;
  value: 0 | 1;
}

function ChoosingPlayer(props: IProps) {
  const { t } = useLingui();
  const options = [
    { label: t`Игрок №1`, value: 0 },
    { label: t`Игрок №2`, value: 1 },
  ];
  const { onChange, value } = props;
  const manager = useEditorManager();

  const onFocusField = useCallback(() => {
    manager?.render();
    history.saveState();
  }, [manager]);

  return (
    <>
      <div className="flex items-center justify-between gap-2">
        <UDText type={'caption-1'}>{t`Игрок`}</UDText>
        <PlayerRoleHint />
      </div>
      <Selector
        onFocus={onFocusField}
        styledEachOption
        onChange={(event) => {
          onChange(event?.value);
        }}
        options={options}
        value={options.find((option) => option.value === value)}
      />
    </>
  );
}

export default ChoosingPlayer;
